import { configuratorActions, hasModel, loadModel, service, getLanguages } from '../../services';
import { getUserAssignments, getTranslationModelName } from '../../util';

function createMaterialConfigurationDataFromTemplate( template ) {
  let result = {
    existingAssignments : getUserAssignments( template ),
    plant: template.plant,
    usage: template.usage,
    configuration: template.materialKey,
    name: template.sourceLocation,
    modelOptimization: template.optimizedModel,
    filters: template.filters,
    masterFilter: template.masterFilter
  };
  return result;
}

function createActionFromDeltaConfiguration( productKey, data ) {
  return {
    type: configuratorActions.COMPLETE,
    key: productKey,
    ...data
  };
}

function createMaterialConfigurationDataFromTemplateWithoutGroup( template, group ) {
  const result = createMaterialConfigurationDataFromTemplate( template );
  result.existingAssignments = result.existingAssignments.filter( assignment => !assignment.key.startsWith( group.title ) );
  return result;
}

function createNewMaterialConfigurationData( template ) {
  return {
    // get only user assignments. Defaults will get assigned on their own.
    // if we get all assignments (like before) then every assignment is treated as user assignment
    // passing second arg true only for VT models
    existingAssignments : getUserAssignments( template,(template.productModelType === 0) ), 
    plant: template.plant,
    usage: template.usage,
    configuration: template.materialKey,
    name: template.sourceLocation
  };
}

function* getAllModelNames( model ) {
  if ( model.sourceLocation ) {
    yield getTranslationModelName( model );
  }
  if ( model.configuration && Array.isArray( model.configuration.children ) ) {
    for ( let child of model.configuration.children ) {
      yield* getAllModelNames( child.childTemplate );
    }
  }
}

const loadTranslationData = dispatch => data => {
  const allModelNames = Array.from( getAllModelNames( data.productData || data ) ).filter( modelName => !hasModel( modelName ) );

  if ( !allModelNames.any() ) {
    return dispatch( data );
  }
  return Promise.all( allModelNames.map( modelName => service( 'translations' )
    .get( [ 'model', modelName ], { headers: { 'Accept-Language': getLanguages().join( ',' ) } } )
    .then( resp => resp.data )
    .then( ( { values, languages, model, category } ) => loadModel( model, category, languages, values ) ) ) )
    .then( () => dispatch( data ) );
};

export const configuratorDispatcher = dispatch => ( {
  loadProduct: ( product, filterGroups, assignments, additionalVariants ) => dispatch( { type: configuratorActions.RESET, product, filterGroups, assignments, additionalVariants } )
    .then( data => loadTranslationData( dispatch )( { type: configuratorActions.LOADED, product, productData: data.data } ) ),
  loadComplexProduct: ( product, modelToLoad ) => dispatch( { type: configuratorActions.LOADCOMPLEX, product, modelToLoad } )
    .then( data => loadTranslationData( dispatch )( { type: configuratorActions.LOADED, product, productData: data.data } ) ),
  fromTemplate: function( configuration, template, assignments, configurationKey ) {
    return dispatch( { type: configuratorActions.FROMTEMPLATE, content: {
      template: createNewMaterialConfigurationData( template ),
      assignments,
      product: configuration.product
    } } ).then( data => 
      loadTranslationData( dispatch )( createActionFromDeltaConfiguration( configurationKey || configuration.product.name || configuration.product.materialNameLso, data.data ) ) 
    );
  },
  loadProductFromModelConfigurator: (product) => dispatch({type: configuratorActions.LOADEDFROMMODELCONFIGURATOR, product: product}),
  removeProductFromModelConfigurator: (product) => dispatch({type: configuratorActions.REMOVEFROMMODELCONFIGURATOR, product: product}),
  productsCheck: function(flag){
    return dispatch({type:configuratorActions.PRODUCTCHECK,productsAvailable:flag})
},
 productsClear:function(){
 return dispatch({type:configuratorActions.ProductsRESET})
},
  assignValue: function( configuration, template, key, value, configurationKey ) {
    return dispatch( { type: configuratorActions.ASSIGN, content: { 
      template: createMaterialConfigurationDataFromTemplate( template ), 
      product: configuration.product, 
      key, 
      value 
    }
    } ).then( data => dispatch( createActionFromDeltaConfiguration( configurationKey || configuration.product.name || configuration.product.materialNameLso, data.data ) ) ).
    catch((err)=>console.log(err));
  },
  removeValue: function( configuration, template, key, value, configurationKey ) {
    return dispatch( { type: configuratorActions.REMOVE, content: { 
      template: createMaterialConfigurationDataFromTemplate( template ), 
      product: configuration.product, 
      key, 
      value 
    } 
    } ).then( data => {
      dispatch( createActionFromDeltaConfiguration( configurationKey || configuration.product.name || configuration.product.materialNameLso, data.data ) );
    } );
  },
  resetGroup: function( configuration, template, group ) {
    return dispatch( { type: configuratorActions.RESETGROUP, content: { 
      template: createMaterialConfigurationDataFromTemplateWithoutGroup( template, group ), 
      product: configuration.product, 
      group
    } 
    } ).then( data => {
      dispatch( createActionFromDeltaConfiguration( configuration.product.name || configuration.product.materialNameLso, data.data ) );
    } );
  },
  removeConfiguration: function( key ) {
    return dispatch( { type: configuratorActions.HARDRESET, product: key } );
  }
} );